import isEmpty from 'lodash/isEmpty'
import snakeCase from 'lodash/snakeCase'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

export const useCurrentProductQueryParams = ({ configurableOptions, bundleOptions }) => {
	const router = useRouter()

	const productConfigurableOptionsQuery = useMemo(
		() =>
			!isEmpty(configurableOptions)
				? configurableOptions?.reduce((acc, { attributeCode }) => {
						const lowKey = Object.keys(router.query).find((queryKey) => queryKey.toLocaleLowerCase() === attributeCode)
						const value = router.query[lowKey]
						return { ...acc, ...(value ? { [attributeCode]: value } : {}) }
				  }, {})
				: null,
		[configurableOptions, router.query]
	)

	const productBundleOptionsQuery = useMemo(
		() =>
			!isEmpty(bundleOptions?.items)
				? bundleOptions?.items?.reduce((acc, { label: _label }) => {
						const label = snakeCase(_label?.toLowerCase?.())
						const lowKey = Object.keys(router.query).find((queryKey) => queryKey === label)
						const value = router.query[lowKey]
						return { ...acc, ...(value ? { [label]: value } : {}) }
				  }, {})
				: null,
		[bundleOptions, router.query]
	)

	return configurableOptions ? productConfigurableOptionsQuery : productBundleOptionsQuery
}
